var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 20.3959 47.1883 16.8381 45.6251 13.5907L41.9489 15.3603C43.2463 18.0556 43.92 21.0086 43.92 24H48Z",
    fill: "#799AA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6259 13.5922C44.0623 10.3433 41.7868 7.48849 38.9684 5.23977L36.4238 8.42901C38.763 10.2954 40.6517 12.665 41.9495 15.3615L45.6259 13.5922Z",
    fill: "#4B9B8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9698 5.2409C36.1517 2.99197 32.863 1.40691 29.3481 0.603464L28.4389 4.58087C31.3563 5.24774 34.0859 6.56334 36.425 8.42995L38.9698 5.2409Z",
    fill: "#529E7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3498 0.603864C25.835 -0.199846 22.1843 -0.201303 18.6688 0.599601L19.5751 4.57767C22.493 3.91292 25.5231 3.91413 28.4404 4.58121L29.3498 0.603864Z",
    fill: "#5EA272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6706 0.599202C15.1551 1.39984 11.8651 2.98228 9.04514 5.22896L11.5875 8.42004C13.9281 6.55529 16.6587 5.24187 19.5766 4.57734L18.6706 0.599202Z",
    fill: "#63A65F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04655 5.22783C6.22639 7.4743 3.94863 10.3273 2.38246 13.5749L6.05744 15.3472C7.35736 12.6517 9.2479 10.2837 11.5886 8.4191L9.04655 5.22783Z",
    fill: "#6DAA49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.38324 13.5733C0.816834 16.8208 0.00225032 20.3795 4.65511e-06 23.9851L4.08 23.9876C4.08187 20.995 4.75797 18.0413 6.05809 15.3458L2.38324 13.5733Z",
    fill: "#78B142"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 2,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.939L33.2976 4.00019",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/Risk.9def0db8dc934262ea8d1b79d767e1d4.svg";
export { ForwardRef as ReactComponent };